'use strict';

angular.module('pulianiBookStoreApp')
	.controller('MycartCtrl', function($scope, MyCart, Global, toaster, $uibModal,$rootScope) {
       $rootScope.title='cart';
		$scope.currencyType = Global.CURRENCY;

		function getCartItems() {
			MyCart.getMyCart().then(function(data) {
				var data = data.data;
                console.log(data);
				for (var index in data.products) {
					data.products[index].quantity = parseInt(data.products[index].quantity);
				}

				$scope.cartData = data;
				if($scope.cartData && $scope.cartData.coupon && $scope.cartData.coupon.warning){
					toaster.pop("warning",$scope.cartData.coupon.warning);
					console.log("cart d data-->", $scope);
					// $scope.couponcode = undefined;
					$scope.removeCoupon();
				}

				
			})
		}

		getCartItems()
		
		$scope.removeItemfromCart = function(productid) {


			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'confirmationBox.html',
				controller: 'ConfirmationCtrl',
				resolve: {
					message: function() {
						return "Do you really want to remove product from the cart?"
					}
				}


			});

			modalInstance.result
				.then(function(response) {
					console.log("response->", response);
				})

			.catch(function(error) {
				if (error === 'delete') {
					MyCart.removeItemfromCart(productid).
					then(function(data) {

						getCartItems();
						console.log("$scope.cartData.======>>>", $scope.cartData, $scope.cartData.products.length);
						if($scope.cartData.products.length == 1){
							$scope.removeCoupon();
						};
						$scope.$emit('checkCartShell');
					})
				}
			})

			//       MyCart.removeItemfromCart(productid).then(function(data)
			// {
			// getCartItems();
			// $scope.$emit('checkCartShell');
			// })
		}

		$scope.$on('onUserStatusChange', function(event, args) {

			getCartItems();
		});

		$scope.makeEditable = function(index) {
			$scope.edit = index;
		}

		var previous = null;

		$scope.validCartDetail = function(index, unitsInStock) {

			if ($scope.cartData && $scope.cartData.products && $scope.cartData.products[index]) {
				if ($scope.cartData.products[index].quantity > unitsInStock) {
					$scope.quantityExceed = true;
				} else {

					$scope.quantityExceed = false;
				}
			}
		}

		$scope.onQuantityChange = function(productid, quantity, unitsInStock, item) {
			if (!quantity) {

				toaster.pop("error", "Please specify valid quantity.");
				return;
			}

			if(quantity >= 101){
				toaster.pop("error", "Order Quantity more than 100 qualifies as a Bulk Order, please conatct customer support for bulk enquires");
			}
			else if (quantity <= unitsInStock) {

				MyCart.onQuantityChange(productid, quantity)

				.then(function(data) {

					toaster.pop("info", "Item Quantity Updated");
					getCartItems();
					$scope.edit = undefined;
				});
			} else {
				toaster.pop("error", "Specified quantity is not available");

			}
		}

		$scope.changeCoupon=function(couponcode){
             if(!couponcode){
		    document.getElementById("coupon_code").setCustomValidity("Please Enter Coupon");
		      }
		    else{
		    	 document.getElementById("coupon_code").setCustomValidity("");

		    }

		}

	    var  checkCouponForDiscount = function(cartitems){
		 var products = cartitems.products;
		 let returnValue = true;
		 for(let i =0; i<products.length; i++){
			 if(products[i]['orignal_price'] !== products[i]['discount_price']){
                 returnValue = false;
			 }
		 }
		 if(returnValue){
			 return true;
		 }else {
			 return false;
		 }
		} 

		$scope.onCouponSubmit = function(couponcode) {

             if(!couponcode){
		      document.getElementById("coupon_code").setCustomValidity("Please Enter Coupon");
		         return;
		       }
			 else{
					 document.getElementById("coupon_code").setCustomValidity("");
				}
			var CoupounDiscountResult = checkCouponForDiscount($scope.cartData);
			if(CoupounDiscountResult){
					let subtotal = $scope.cartData.price.subTotal;
					MyCart.UserValidateCoupon(couponcode, subtotal)
					
					.then(function(data) {
						console.log(data);
						getCartItems();
					})

					.catch(function(error) {
						console.log('error');
						toaster.pop("warning", error.data.message);
					});
			}else {
				toaster.pop("warning", "Sorry! Promo code cannot be applied since your cart contains one or more discounted items. Promo codes are applicable only on non-discounted items. In order to apply the promo code please order the non-discounted items separately");
			}	
			
		}

		$scope.removeCoupon = function(couponcode) {

			MyCart.RemoveUserCoupon(couponcode).then(function(data) {
				getCartItems();
			});
		}


	});